export class WelcomeValidationKey {
  static readonly PASSWORD_REQUIREMENT = 'welcome/validation/password-requirement';
}
